import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/app/lib/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestsService {
  api_user_profile() {
    throw new Error('Method not implemented.');
  }

  constructor(
    private http: HttpClient,
    private env: environment
  ) { }

  private getAuthHeader(): HttpHeaders {
    const username = localStorage.getItem('username');
    const encodedPassword = localStorage.getItem('encodedPassword');
    const password = atob(encodedPassword);
    const authHeader = 'Basic ' + btoa(username + ':' + password);


    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: authHeader
    });
  }

private getAuthHeader2(): HttpHeaders {
    const username = localStorage.getItem('username');
    const encodedPassword = localStorage.getItem('encodedPassword');
    const password = atob(encodedPassword);
    const authHeader = 'Basic ' + btoa(username + ':' + password);


    return new HttpHeaders({
      Authorization: authHeader
    });
  }

  post(url, data): any {
    const httpOptions = {
      headers: this.getAuthHeader()
    };


    return new Promise((resolve) => {
      this.http.post(this.env.getUrl(url), data, httpOptions).subscribe(
        result => {
          resolve(result);
        },
        error => {
          resolve(error);
        }
      );
    });
  }

  postBlob(url, data): any {
    const httpOptions = {
      headers: this.getAuthHeader(),
      responseType: 'blob' as 'json'
    };


    return new Promise((resolve) => {
      this.http.post(this.env.getUrl(url), data, httpOptions).subscribe(
        result => {
          resolve(result);
        },
        error => {
          resolve(error);
        }
      );
    });
  }

  get(url): any {
    const httpOptions = {
      headers: this.getAuthHeader()
    };


    return new Promise((resolve) => {
      this.http.get(this.env.getUrl(url), httpOptions).subscribe(
        result => {
          resolve(result);
        },
        error => {
          resolve(error);
        }
      );
    });
  }

  put(url, data, customOptions: any = {}): any {
      const defaultOptions = {
        headers: this.getAuthHeader()
      };

      // Merge custom headers if provided
      const httpOptions = {
        headers: new HttpHeaders({
          ...defaultOptions.headers?.keys()?.reduce((acc, key) => ({ ...acc, [key]: defaultOptions.headers.get(key) }), {}),
          ...customOptions.headers
        })
      };


      return new Promise((resolve) => {
        this.http.put(this.env.getUrl(url), data, httpOptions).subscribe(
          result => {
            resolve(result);
          },
          error => {
            resolve(error);
          }
        );
      });
    }

  debounce(func, wait) {
    let timeout;

    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };

      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }


  post2(url, data): any {

    const httpOptions = {
      headers: new HttpHeaders({
        // Add other headers here, but exclude authentication headers
        'Content-Type': 'application/json'
      })
    };

    return new Promise((resolve) => {
      this.http.post(this.env.getUrl(url), data, httpOptions).subscribe(
        result => {
          resolve(result);
        },
        error => {
          resolve(error);
        }
      );
    });
  }
    put2(url, data, customOptions: any = {}): any {
        const defaultHeaders = this.getAuthHeader2(); // No Content-Type here

        const baseHeaders = defaultHeaders.keys().reduce((acc, key) => {
            acc[key] = defaultHeaders.get(key);
            return acc;
        }, {} as { [key: string]: string });

        const mergedHeaders = {
            ...baseHeaders,
            ...(customOptions.headers || {})
        };

        const httpOptions = {
            headers: new HttpHeaders(mergedHeaders)
        };

        return new Promise((resolve) => {
            this.http.put(this.env.getUrl(url), data, httpOptions).subscribe(
            result => resolve(result),
            error => resolve(error)
            );
        });
    }

    postFormWithImage(url, data): any {
        const httpOptions = {
            headers: this.getAuthHeader2() 
        };


        return new Promise((resolve, reject) => {
            this.http.post(this.env.getUrl(url), data, httpOptions).subscribe({
                next: (result) => resolve(result),
                error: (error) => reject(error)
            });
            });
        }

}
